var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.link)?_c('a',{class:{ mobile: _vm.$mq === 'sm' },attrs:{"href":_vm.link.link_url.url,"title":_vm.link.link_title}},[_vm._v(" "+_vm._s(_vm.link.link_title)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }